import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoStaffByCVStaffModalForm } from 'src/components/peoStaff';
import { ModalId } from 'src/constants/modals';
import { usePeoById } from 'src/hooks/peo';
import { useModal } from 'src/hooks/shared';

import type { InvitePeoStaffByCVStaffModalArgs } from './types';

export const InvitePeoStaffByCVStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<InvitePeoStaffByCVStaffModalArgs>(ModalId.InvitePeoStaffByCVStaffModal);

  const { isPartnership } = usePeoById(args?.peoId);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title={isPartnership ? 'Invite Partnership Staff' : 'Invite PEO Staff'}
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={740}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <InvitePeoStaffByCVStaffModalForm
        peoId={args?.peoId}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
